import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=b5c56f80&scoped=true"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "./quotation.vue?vue&type=style&index=0&id=b5c56f80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c56f80",
  null
  
)

export default component.exports